"use client";
import { Html } from "@custom/schema";
import React from "react";
export default function AlertBox(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container mb-9 md:mb-12"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "alert",
        "aria-live": "assertive",
        className: "border-4 border-red-500 px-5 py-4 prose max-w-full alert-box"
    }, props.alertHeading && /*#__PURE__*/ React.createElement("h4", {
        className: "font-semibold text-red-500"
    }, props.alertHeading), /*#__PURE__*/ React.createElement(Html, {
        markup: props.alertText
    })));
}
